import { useState } from 'react'
import { clsx } from 'clsx'
import type { MediaItem } from '../types'

/** A single media tile (poster image; videos show their thumbnail + a ▶ badge
 *  to keep tiles light — actual playback happens in the Lightbox). */
export function MediaTile({
  item,
  onClick,
  className,
  eager,
}: {
  item: MediaItem
  onClick?: (e: React.MouseEvent) => void
  className?: string
  eager?: boolean
}) {
  const [broken, setBroken] = useState(false)
  const showPoster = !!item.src && !broken
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'group relative block overflow-hidden rounded-xl border border-edge bg-[#0a0a0f] shadow-cyber transition',
        'hover:border-pow hover:shadow-neon-pink focus-visible:border-pow focus-visible:shadow-neon-pink',
        'active:translate-y-[1px]',
        className,
      )}
      aria-label={item.alt || `${item.kind} from @${item.authorHandle ?? 'bluesky'}`}
    >
      {showPoster ? (
        <img
          src={item.src}
          alt={item.alt ?? ''}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          draggable={false}
          onError={() => setBroken(true)}
          className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
        />
      ) : (
        <div className="grid h-full w-full place-items-center bg-gradient-to-br from-boom to-pow font-comic text-2xl text-white">
          {item.kind === 'video' ? '▶' : '✦'}
        </div>
      )}
      {item.kind === 'video' ? (
        <span className="absolute bottom-1 right-1 grid h-7 w-7 place-items-center rounded-full border border-kapow bg-ink/80 text-sm text-kapow shadow-neon-cyan backdrop-blur">
          ▶
        </span>
      ) : null}
    </button>
  )
}
